import { CreateDataUpdateInput, UpdateDataUpdateInput } from "src/app/shared/graphql/generated/graphql";

export namespace DataUpdates {
  export class GetDataUpdates {
    static readonly type = '[DataUpdates] GetDataUpdates';
  }

  export class BulkReplaceDataUpdates {
    static readonly type = '[DataUpdates] BulkReplaceDataUpdates';
    constructor(public bulkReplaceDataUpdateInput: CreateDataUpdateInput[]) { }
  }


  export class CreateDataUpdate {
    static readonly type = '[DataUpdates] CreateDataUpdate';
    constructor(public createDataUpdateInput: CreateDataUpdateInput) { }
  }

  export class UpdateDataUpdate {
    static readonly type = '[DataUpdates] UpdateDataUpdate';
    constructor(public updateDataUpdateInput: UpdateDataUpdateInput) { }
  }

  export class RemoveDataUpdate {
    static readonly type = '[DataUpdates] RemoveDataUpdate';
    constructor(public dataUpdateId: number) { }
  }
  export class AddProductToDataUpdate {
    static readonly type = '[DataUpdates] AddProductToDataUpdate';
    constructor(public dataUpdateId: number, public productId: number) { }
  }

  export class AddProductsToDataUpdate {
    static readonly type = '[DataUpdates] SetProductsToDataUpdate';
    constructor(public dataUpdateId: number, public productIds: number[]) { }
  }
  export class RemoveProductFromDataUpdate {
    static readonly type = '[DataUpdates] RemoveProductFromDataUpdate';
    constructor(public dataUpdateId: number, public productId: number) { }
  }

  export class RemoveProductsFromDataUpdate {
    static readonly type = '[DataUpdates] RemoveProductsFromDataUpdate';
    constructor(public dataUpdateId: number, public productIds: number[]) { }
  }
}
